import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import i18n from 'i18n';
import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';


const Notice = ({ className }) => (
  <div className={className}>
    <h3 className="home-notice__title">お知らせ</h3>
    <ul className="home-notice__list">
      <li>
        <dl>
          {/* INFO 利用可能施設のお知らせ
          <dt><u>{i18n.t('notice:available.title')}</u></dt>
          <dd>
            <p>{i18n.t('notice:available.lead')}</p>
            <div className="home-notice__list--facilities">
              <div className="home-notice__list--facilities__item">{i18n.t('notice:available.messages.1')}</div>
              <div className="home-notice__list--facilities__item">{i18n.t('notice:available.messages.2')}</div>
              <div className="home-notice__list--facilities__item">{i18n.t('notice:available.messages.3')}</div>
              <div className="home-notice__list--facilities__item">{i18n.t('notice:available.messages.4')}</div>
              <div className="home-notice__list--facilities__item">{i18n.t('notice:available.messages.5')}</div>
              <div className="home-notice__list--facilities__item">{i18n.t('notice:available.messages.6')}</div>
            </div>
          </dd>
          */}
          {/** メンテナンス情報 */}
          {i18n.t('notice:maintenance.begin') && <dt><u>{i18n.t('notice:maintenance.title')}</u></dt>}
          {i18n.t('notice:maintenance.begin') &&
            <dd>
              <div><u>{i18n.t('notice:maintenance.messages.1')}</u></div>
            </dd>
          }
          {/** お盆情報 */}
          {i18n.t('notice:obon.show') && <dt>{i18n.t('notice:obon.title')}</dt>}
          {i18n.t('notice:obon.show') &&
            <dd>
              <p>
                <div>{i18n.t('notice:obon.messages.1')}</div>
                <div>{i18n.t('notice:obon.messages.2')}</div>
                <div>{i18n.t('notice:obon.messages.3')}</div>
                <div>{i18n.t('notice:obon.messages.4')}</div>
                <div>{i18n.t('notice:obon.messages.5')}</div>
              </p>
            </dd>
          }
          {/** 観光庁や都道府県による観光支援策 */}
          {i18n.t('notice:gtt.show') && <dt>{i18n.t('notice:gtt.title')}</dt>}
          {i18n.t('notice:gtt.show') &&
            <dd>
              <p>{i18n.t('notice:gtt.lead')}</p>
              <p>
                <div>{i18n.t('notice:gtt.messages.1')}</div>
              </p>
            </dd>}
          {/** 施設追加のお知らせ */}
          {i18n.t('notice:available.show') && <dt>{i18n.t('notice:available.title')}</dt>}
          {i18n.t('notice:available.show') && <dd><p>{i18n.t('notice:available.lead')}</p></dd>}
          {/** GWまたは年末年始の配送スケジュール情報 */}
          {i18n.t('notice:delivery.show') && <dt>{i18n.t('notice:delivery.title')}</dt>}
          {i18n.t('notice:delivery.show') &&
            <dd>
              <p>
                <div>{i18n.t('notice:delivery.messages.1')}</div>
                <div>{i18n.t('notice:delivery.messages.2')}</div>
                <div>{i18n.t('notice:delivery.messages.3')}</div>
                <div>{i18n.t('notice:delivery.messages.4')}</div>
                <div>{i18n.t('notice:delivery.messages.5')}</div>
                <div>{i18n.t('notice:delivery.messages.6')}</div>
                <div>{i18n.t('notice:delivery.messages.7')}</div>
              </p>
            </dd>
          }
          {/** 割引プランとの併用 */}
          {i18n.t('notice:discountPlans.show') && <dt>{i18n.t('notice:discountPlans.title')}</dt>}
          {i18n.t('notice:discountPlans.show') &&
            <dd>
              <div>{i18n.t('notice:discountPlans.messages.1')}</div>
            </dd>
          }
          {/** OMOポイント交換 */}
          {i18n.t('notice:exchangeOMOPoints.show') && <dt>{i18n.t('notice:exchangeOMOPoints.title')}</dt>}
          {i18n.t('notice:exchangeOMOPoints.show') &&
            <dd>
              <div>
                <a href="https://hoshinoresorts.com/jp/sp/point/" target="blank">{i18n.t('notice:exchangeOMOPoints.messages.1')}</a>
                {i18n.t('notice:exchangeOMOPoints.messages.2')}
              </div>
            </dd>
          }
        </dl>
      </li>
    </ul>
  </div>
);

const commonStyle = css`
  background: ${Colors.gray4};
  border: solid 1px ${Colors.gray2};
  border-radius: 8px;

  p, ul, dl {
    margin: 0.75em 0 0;

    &:first-child {
      margin-top: 0;
    }
  }

  dt, dd {
    display: block;
    padding: 0;
    margin: 0;
  }

  dt {
    margin-bottom: 0.25em;
    margin-top: 1em;
    color: #ff6e3c;
    font-weight: bold;
    font-size: 20px;
    &:first-child {
      margin-top: 0;
    }
  }

  li + li {
    margin-top: 0.25em;
  }

  small {
    display: block;
    ${FontStyles.text11};
  }

  .home-notice__title {
    ${FontStyles.text8};
    letter-spacing: 3px;
    white-space: nowrap;
    margin: 0;
  }

  .home-notice__list {
    list-style: none;
    margin: 0;
    padding: 0;

    ul {
      list-style-type: disc;
      ul {
        list-style-type: circle;
      }
    }

    & > li + li {
      margin-top: 20px;
    }

    li {
      ${FontStyles.text8};
    }

    a {
      color: ${Colors.orange1};
    }
    &--facilities {
      display: flex;
      flex-wrap: wrap;
      margin-left: 2em;
      margin-top: 1em;
      &__item {
        flex-basis: 30%;
        min-width: 10em;
        &::before {
          content: "\\2022";
          margin-right: 5px;
        }
      }
    }
  }
  .cashless__logo {
    float:right;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  margin: 0 80px;
  display: flex;
  flex-wrap: nowrap;
  padding: 32px;

  .home-notice__title {
    flex: 0 0 auto;
    padding-right: 32px;
  }


  .home-notice__list {
    flex: 1 1 100%;
    border-left: solid 1px ${Colors.gray2};
    padding-left: 32px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin: 0 16px;
  padding: 16px;

  .home-notice__list {
    margin-top: 10px;
  }
`;

export default applyStyles(Notice)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Home/components/Notice.js